import { DateTime } from 'luxon'

export const sumTotal = (values: number[]) =>
  values.reduce((acc, current) => acc + Number(current), 0)

export const localizedMonthName = (
  monthNumber: string,
  year: string,
  langCode: string
) => {
  const monthName = DateTime.fromObject({
    year: Number(year),
    month: Number(monthNumber),
  })
    .setLocale(langCode)
    .toFormat('LLLL')

  return capitalizeFirstLetter(monthName)
}

const capitalizeFirstLetter = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const localizeCurrency = (value: number) =>
  value.toLocaleString('fi-FI', { style: 'currency', currency: 'EUR' })

export const toShortDate = (date: string) =>
  DateTime.fromISO(date).toFormat('dd.MM.')

export const hideCurrentYear = (year: string): string =>
  DateTime.now().toFormat('yyyy') === year ? '' : year
